import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-81aad5d6")

_pushScopeId("data-v-81aad5d6")
const _hoisted_1 = { class: "max-w-container px-container" }
const _hoisted_2 = { class: "pt-8 lg:pt-16 xl:pt-32 max-w-container px-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Kit prensa"))
const _hoisted_4 = { class: "press-table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PostsBlock = _resolveComponent("PostsBlock")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_PageTitle, null, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createVNode("table", _hoisted_4, [
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pressLinksByDays, (day) => {
            return (_openBlock(), _createBlock("tr", {
              key: day.date
            }, [
              _createVNode("td", null, [
                _createVNode("a", {
                  class: "font-display text-uppercase underline hover:text-amff-teal",
                  href: day.links.day
                }, _toDisplayString(_ctx.formatDay2(day.date, "es")), 9, ["href"])
              ]),
              _createVNode("td", null, [
                _createVNode("a", {
                  class: "underline hover:text-amff-teal",
                  href: day.links.agenda
                }, " Agenda ", 8, ["href"])
              ]),
              _createVNode("td", null, [
                _createVNode("a", {
                  class: "underline hover:text-amff-teal",
                  href: day.links.pressNotes
                }, " Notas de prensa ", 8, ["href"])
              ]),
              _createVNode("td", null, [
                _createVNode("a", {
                  class: "underline hover:text-amff-teal",
                  href: day.links.materials
                }, " Materiales ", 8, ["href"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_PostsBlock)
  ], 64))
})